import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useEvent, useStore } from "effector-react";
import { toast } from "react-toastify";
import { Preloader } from "../../../common/ui/Preloader/preloader";
import {
  IAccount,
  queryNewAccount,
  queryAccountsChange,
  $accounts,
  AccountsDoneLoading,
  AddOwnerTypeToAccount,
  AddChargesToAccount,
  updateAccount,
  queryAccounts,
} from "../../../common/accounts2";

import "react-toastify/dist/ReactToastify.css";
import { Questionaire } from "../../login/molecules/questionnaire";
import axios from "axios";
import { getUuidAndSession } from "../../../common/localStorage";
import { getCustomUserAgent, getCustomUserAgentASB, getCustomUserAgentKrk } from "../../../common/customUserAgent";
import { $SiteColors } from "../../../common/config/company-atts";
toast.configure();

interface INewAccountKrkCitizen {
  setNewAccount: React.Dispatch<React.SetStateAction<IAccount | null>>;
  onCancelClicked: () => void;
  hideAnon: boolean;
  onAnonClicked: () => void;
  isValid: boolean;
  setIsValid: React.Dispatch<React.SetStateAction<boolean>>;
  disableWhileLoading: boolean;
  setDisableWhileLoading: React.Dispatch<React.SetStateAction<boolean>>;
  redirectTo: string;
  comId: string;
}

export const NewAccountKrkCitizen = ({
  setNewAccount,
  onCancelClicked,
  hideAnon,
  onAnonClicked,
  isValid,
  setIsValid,
  disableWhileLoading,
  setDisableWhileLoading,
  redirectTo,
  comId
}: INewAccountKrkCitizen) => {
  const [values, setValues] = React.useState({
    account_num: "",
    name: "",
    patronymic: "",
    surname: "",
    INN: ''
  });
  const [activeQuestinary, setActiveQuestinary] = useState(false)
  const [eventData, setEventData] = useState<React.FormEvent<HTMLFormElement>>()


  const form = React.useRef<HTMLFormElement>(null);
  const history = useHistory();
  const { accounts } = useStore($accounts);

  React.useEffect(() => {
    if (form.current) setIsValid(form.current.checkValidity());
  }, [values]);
  useEffect(() => {
    console.log(accounts)
  }, [accounts])
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const target = event.target;
    const name = target.name;
    const value = target.value;
    setValues({ ...values, [name]: value });
  };
  const beforeHandleForm = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    console.log(values)
    const { uuid, session } = getUuidAndSession();
    axios.post("https://izba.kras-abs.ru/api/v3/user/addAccount", {
      accParams: {
        account: values.account_num, //937060052171
        companyId: $SiteColors.getState().ComId.toString(),
        first_name: values.name,
        last_name: values.surname,
        middle_name: values.patronymic,
        inn: values.INN
      },
      uuid: uuid,
      session: session
    },
      {
        headers: {
          "Custom-User-Agent": getCustomUserAgent(),
          // "Authorization": "Basic"+btoa(unescape(encodeURIComponent("ОбменДанными"+":1qazxsw@"))),
          "Content-Type": "application/json",
        }
      }).then((res => {
        if (res.data.account !== null) {
          console.log(res.data)
          if (comId === "34") {
            setActiveQuestinary(true)
          }
          else {
            queryAccounts()
            .then(async res => {
              var bar = new Promise((resolve, reject) => {
                res.accounts.forEach(async (elem, index) => {
                  await updateAccount({ account: elem, accounts: res.accounts });
                    await AddChargesToAccount({ account: elem, accounts: res.accounts })
                  if (getCustomUserAgent() === getCustomUserAgentKrk()
                    // ||getCustomUserAgent() === getCustomUserAgentASB()
                  ) {
                    await AddOwnerTypeToAccount({ account: elem, accounts: res.accounts })
                  }
                  if (index === res.accounts.length - 1) resolve("@");
                })
              })
              bar.then(() => {
                AccountsDoneLoading()
              }).finally(() => {
                AccountsDoneLoading()
              })
              // queryAccountsChange(accounts.concat(res));
            })
            
            history.push(redirectTo)
          }
          setEventData(event)
          console.log(res)
        } else {
          toast.error("Данного аккаунта не существует. Проверьте правильность ввода данных");
        }
      }

      )).catch((res)=>{
        console.log(res.response)
        toast.error(res.response.data.error)
      }
      )

  }
  const handleFormSubmitAccount = (event: React.FormEvent<HTMLFormElement> | undefined) => {
    if (event !== undefined) {
      const newData = { accParams: values }
      event.preventDefault();
      setDisableWhileLoading(true);
      setIsValid(false);
      queryNewAccount({
        data: newData,
        setNewAccount,
        setDisableWhileLoading,
        setIsValid,
      })
        .then((res) => {
          queryAccountsChange(accounts.concat(res));
        })
        .then(() => history.push(redirectTo))
        .catch((err) => {
          console.log(err)
          toast.error(err.message);
          setNewAccount(null);
          setDisableWhileLoading(false);
          setIsValid(true);
        });
    };
  }

  return (
    <>
      <form
        className="login__form addacc__form"
        ref={form}
        onSubmit={beforeHandleForm}
      >
        <input
          type="text"
          className="login__input addacc__input"
          placeholder={comId !== "56" ? "Введите лицевой счет" : "Введите номер договора"}
          name="account_num"
          required
          id="account"
          maxLength={30}
          autoComplete="off"
          value={values.account_num}
          onChange={handleChange}
          disabled={disableWhileLoading}
        ></input>
        <input
          type="text"
          className="login__input addacc__input"
          placeholder="Введите Вашу фамилию"
          name="surname"
          required
          id="surname"
          maxLength={30}
          autoComplete="off"
          value={values.surname}
          onChange={handleChange}
          disabled={disableWhileLoading}
        ></input>
        <input
          type="text"
          className="login__input addacc__input"
          placeholder="Введите Ваше имя"
          name="name"
          required
          id="name"
          maxLength={30}
          autoComplete="off"
          value={values.name}
          onChange={handleChange}
          disabled={disableWhileLoading}
        ></input>
        <input
          type="text"
          className="login__input addacc__input"
          placeholder="Введите Ваше отчество"
          name="patronymic"
          required
          id="patronymic"
          maxLength={30}
          autoComplete="off"
          value={values.patronymic}
          onChange={handleChange}
          disabled={disableWhileLoading}
        ></input>
        {comId === "56" ?
          <input
            type="text"
            className="login__input addacc__input"
            placeholder="Введите Ваш ИНН"
            name="INN"
            required
            id="INN"
            maxLength={30}
            autoComplete="off"
            value={values.INN}
            onChange={handleChange}
            disabled={disableWhileLoading}
          ></input>
          : null}
        <div className="addacc__buttons addacc__buttons_space">
          <button
            type="submit"
            className="addacc__button addacc__button_decision addacc__button_decision_submit"
            style={{ backgroundColor: $SiteColors.getState().backBtnSubmit }}
            disabled={!isValid}
          >
            {disableWhileLoading ? <Preloader small={true} /> : "Добавить"}
          </button>
          {hideAnon ? (
            <button
              onClick={onCancelClicked}
              className="addacc__button addacc__button_decision addacc__button_decision_cancel"
              disabled={disableWhileLoading}
              type="button"
            >
              Отмена
            </button>
          ) : (
            <button
              hidden={hideAnon}
              className="addacc__button addacc__button_decision addacc__button_decision_anonim"
              onClick={onAnonClicked}
              disabled={disableWhileLoading}
              type="button"
            >
              Анонимный вход
            </button>
          )}
        </div>
      </form>
      {/* <Questionaire active={activeQuestinary} setActive={setActiveQuestinary} values={values} done={handleFormSubmitAccount} eventData={eventData} /> */}
    </>
  );
};
